import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallbackPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const processAuth = async () => {
      try {
        // Get session_id from URL hash
        const hash = window.location.hash;
        if (!hash.includes('session_id=')) {
          setError('No session ID found');
          setTimeout(() => navigate('/login'), 2000);
          return;
        }

        const sessionId = hash.split('session_id=')[1].split('&')[0];
        
        // Process session with backend
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        // Store session token for mobile
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }

        // Check if user is approved
        if (!response.data.user.is_approved) {
          // Redirect to access denied
          navigate('/access-denied');
          return;
        }

        // Success - redirect to viewer
        window.location.href = '/viewer';
        
      } catch (error) {
        console.error('Auth callback error:', error);
        setError(error.response?.data?.detail || 'Authentication failed');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-600 text-xl mb-4">❌ {error}</div>
            <p className="text-gray-600">Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Completing sign in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallbackPage;
